import { t } from '@/core/localization';
import { convertDateRangeValueToApiFormat } from '@/core/utils/datetime';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { baseApi } from '@/warehouse/baseApi';
import { createCrossdockingHubCacheListener } from '@/warehouse/signalR';
import { crossdockBlockedActions } from './crossdockBlocked.state';
export const crossdockBlockedApi = baseApi.enhanceEndpoints({ addTagTypes: ['BlockedStickers'] }).injectEndpoints({
    endpoints: (builder) => ({
        getBlockedStickers: builder.query({
            query: ({ crossDockId, dateFrom, dateTo }) => ({
                method: 'GET',
                url: `crossdocking/receipt/sticker`,
                params: {
                    crossdockingId: Number(crossDockId),
                    isBlocked: true,
                    ...convertDateRangeValueToApiFormat({ dateFrom, dateTo }),
                },
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                    // TODO: Mb use selectors from api instead of state? (everywhere in project)
                    dispatch(crossdockBlockedActions.setItemCount(result.data?.length ?? 0));
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.blocked.items.request.failed'), error }));
                }
            },
            // Updates are handled by socket messages.
            // providesTags: (result) => providesList(result, 'BlockedList', 'stickerId'),
            onCacheEntryAdded: createCrossdockingHubCacheListener(({ updateCachedData }) => ({
                CreateOrDeleteStickerItem: (message) => {
                    updateCachedData((draft) => {
                        if (message.isDeletion) {
                            const itemIndex = draft.findIndex((sticker) => sticker.stickerId === message.stickerId);
                            if (itemIndex === -1)
                                return;
                            draft.splice(itemIndex, 1);
                        }
                        else {
                            // block sticker is handled by StickerBlocked message.
                        }
                    });
                },
                StickerBlocked: (message) => {
                    updateCachedData((draft) => {
                        const itemIndex = draft.findIndex((sticker) => sticker.stickerId === message.stickerId);
                        if (itemIndex !== -1)
                            return;
                        draft.push(message);
                        // What is actually needed
                        // draft.push(
                        // 	extractFields<BlockedSticker>(
                        // 		message,
                        // 		'trackableStatus',
                        // 		'createDate',
                        // 		'supplierName',
                        // 		'userName',
                        // 		'brand',
                        // 		'name',
                        // 		'article',
                        // 		'quantity',
                        // 		'stickerId',
                        // 		'invoiceId',
                        // 		'invoiceNumber',
                        // 		'invoiceDate',
                        // 		'warehouseman',
                        // 		'blockReason'
                        // 	)
                        // );
                    });
                },
            })),
        }),
        unblockSticker: builder.mutation({
            query: ({ crossDockId, stickerId }) => ({
                method: 'POST',
                url: `crossdocking/${crossDockId}/sticker/block`,
                body: { stickerId, blocked: false },
            }),
            // Socket invalidates request.
            // invalidatesTags: (result, error, { stickerId }) => (error ? [] : [{ type: 'BlockedStickers', id: stickerId }]),
        }),
    }),
});
export const { useGetBlockedStickersQuery, useUnblockStickerMutation } = crossdockBlockedApi;
